import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CrescentIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M14.76 4.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        }),
                        _jsx("path", {
                            d: "M18.16 3a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 2a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M19.971 10.41a1.1 1.1 0 112.2 0 1.1 1.1 0 01-2.2 0zM18.34 10.793a1.1 1.1 0 10-1.555 1.556 1.1 1.1 0 001.555-1.556zM14.26 8.81a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2zM13.878 7.18a1.1 1.1 0 10-1.556-1.556 1.1 1.1 0 001.556 1.556zM5.86 13.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0z"
                        }),
                        _jsx("path", {
                            d: "M8.16 13a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 2a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M9.971 20.41a1.1 1.1 0 112.2 0 1.1 1.1 0 01-2.2 0zM8.34 20.793a1.1 1.1 0 10-1.556 1.556 1.1 1.1 0 001.556-1.556zM4.26 18.81a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2zM3.878 17.18a1.1 1.1 0 10-1.556-1.556 1.1 1.1 0 001.556 1.556z"
                        })
                    ]
                })
            })
        ]
    });
};
CrescentIcon.isCarinaIcon = true;
export default CrescentIcon;
